module.exports = __webpack_public_path__ + "img/arrow-menu.cb5b517b.svg";